"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _localityState = _interopRequireDefault(require("./locality-state"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var LocalityCommonRegion = {
  CANBERRA: {
    id: 391,
    type: 'REGION',
    name: 'Canberra',
    slug: 'canberra-act',
    metaData: {
      state: 'ACT'
    },
    regionId: 391,
    state: _localityState.default.ACT
  },
  QUEANBEYAN: {
    id: 557,
    type: 'REGION',
    name: 'Queanbeyan Region',
    slug: 'queanbeyan-region-nsw',
    metaData: {
      state: 'NSW'
    },
    regionId: 557,
    state: _localityState.default.NSW
  },
  SOUTHERN_TABLELANDS: {
    id: 537,
    type: 'REGION',
    name: 'Southern Tablelands',
    slug: 'southern-tablelands-nsw',
    regionId: 537,
    metaData: {
      state: 'NSW'
    },
    state: _localityState.default.NSW
  }
};
var _default = exports.default = LocalityCommonRegion;